import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Login from './pages/Login';
import Guest from './pages/Guest';
import SignupPage from './pages/SignupPage';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Help from './pages/Help';
import PrivateRoute from './pages/PrivateRoute';
import ErrorPage from './pages/ErrorPage';
import MyFamilyTree from './pages/MyFamilyTree';
import MyFamily from './pages/MyFamily';
import FindRelation from './pages/FindRelation';
import Gallery from './pages/Gallery';
import Setting from './pages/Setting';
import Partner from './pages/Partner';

import AdminPage from './pages/AdminPage';
import AdminAddressPage from './pages/AdminAddressPage';
import AdminInvoices from './pages/AdminInvoices';
import AdminRoute from './components/AdminRoute';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import theme from './theme';

import Welcome from './pages/Welcome';
import Footer from './components/Footer';

import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ContactUs from './pages/ContactUs';

import { ErrorProvider } from './ErrorContext';
import Logout from './pages/Logout';
import GlobalErrorHandler from './GlobalErrorHandler';

function App() {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  return (
    <GlobalErrorHandler>
      <ErrorProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
            }}
          >
            <Router basename="/chaudharylife">
              <Box sx={{ flex: 1 }}>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<Welcome />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/guest" element={<Guest />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/contact-us" element={<ContactUs />} />

                  {/* Admin Routes */}
                  <Route element={<AdminRoute />}>
                    <Route path="/dashboard" element={<AdminPage />} />

                    <Route
                      path="/admin/dashboard"
                      element={<AdminPage />}
                    />

                    <Route
                      path="/admin/addresses"
                      element={<AdminAddressPage />}
                    />

                    <Route
                      path="/admin/invoices"
                      element={<AdminInvoices />}
                    />
                  </Route>

                  {/* Logged In User Routes */}
                  <Route
                    element={
                      <PrivateRoute isLoggedIn={isLoggedIn} />
                    }
                  >
                    <Route
                      path="/find-partner"
                      element={<Partner />}
                    />

                    <Route
                      path="/find-relation"
                      element={<FindRelation />}
                    />

                    <Route
                      path="/my-family-tree"
                      element={<MyFamily />}
                    />

                    <Route
                      path="/find-people"
                      element={<Home />}
                    />

                    <Route
                      path="/settings"
                      element={<Setting />}
                    />

                    <Route
                      path="/home"
                      element={<MyFamilyTree />}
                    />

                    <Route
                      path="/profile"
                      element={<Profile />}
                    />

                    <Route
                      path="/help"
                      element={<Help />}
                    />

                    <Route
                      path="/picture-gallery"
                      element={<Gallery />}
                    />
                  </Route>

                  {/* Other Routes */}
                  <Route path="/logout" element={<Logout />} />

                  <Route
                    path="/privacy-policy"
                    element={<PrivacyPolicy />}
                  />

                  <Route
                    path="/terms-of-service"
                    element={<TermsOfService />}
                  />

                  <Route path="*" element={<ErrorPage />} />
                </Routes>
              </Box>

              <Footer />
            </Router>
          </Box>
        </ThemeProvider>
      </ErrorProvider>
    </GlobalErrorHandler>
  );
}

export default App;